import React, { useMemo } from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { paginate } from '@utils/template-category/paginate';
import { TEMPLATE_LIMIT } from '@constants/templates';

interface CategoryPaginationProps {
  totalPages: number;
  currentPage: number;
}

function CategoryPagination(props: CategoryPaginationProps) {
  const { totalPages, currentPage } = props;

  const router = useRouter();
  const handlePagination = (page: number) => {
    router.push(`${router.asPath}?page=${page}`);
  };

  const pages = useMemo(() => {
    const maxPage = totalPages > 5 ? 5 : totalPages;

    const page = paginate(
      totalPages * TEMPLATE_LIMIT,
      currentPage,
      TEMPLATE_LIMIT,
      maxPage,
    );

    return page.pages;
  }, [currentPage, totalPages]);

  return (
    <div className={ivclass('iv-flex iv-items-center iv-justify-evenly')}>
      {pages.map(key => (
        <div className={ivclass('iv-mr-5')} key={key}>
          <Link
            href={{
              pathname: `/templates/${router.query?.category || ''}`,
              query: { page: key },
            }}
            className={ivclass(
              'iv-rounded iv-px-10 iv-py-5',
              'iv-text-body-m iv-font-medium iv-text-grey-60',
              key === currentPage && 'iv-bg-lightblue-10 ',
            )}
          >
            {key}
          </Link>
        </div>
      ))}

      <div className={ivclass('iv-mr-5')}>
        <button
          className={ivclass(
            'iv-group',
            'iv-flex iv-items-center',
            'iv-rounded iv-px-10 iv-py-5',
            'iv-border iv-border-grey-85',
            'iv-text-body-m iv-font-medium iv-text-grey-85',
          )}
          type="button"
          disabled={currentPage === totalPages}
          onClick={() => handlePagination(currentPage + 1)}
        >
          Next{' '}
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="iv-ml-5 group-hover:iv-translate-x-1 iv-transition-transform iv-ease-in iv-duration-100"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.2298 12.8743C10.0345 12.679 10.0345 12.3625 10.2298 12.1672L13.2929 9.10408L1.5 9.10408C1.22386 9.10408 1 8.88023 1 8.60408C1 8.32794 1.22386 8.10408 1.5 8.10408L13.2929 8.10408L10.2298 5.04097C10.0345 4.84571 10.0345 4.52913 10.2298 4.33386C10.425 4.1386 10.7416 4.1386 10.9369 4.33386L14.8536 8.25053C15.0488 8.44579 15.0488 8.76238 14.8536 8.95764L10.9369 12.8743C10.7416 13.0696 10.425 13.0696 10.2298 12.8743Z"
              fill="#262626"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default CategoryPagination;
